export enum AppType
{
    Dealership = 0,
    ServiceCenter = 1
};

export namespace AppType
{
    export function toString( type: AppType )
    {
        switch( type )
        {
            case AppType.Dealership: return 'Dealership';
            case AppType.ServiceCenter: return 'Service Center';
        }
    }
}
